import type { ComponentProps } from 'react';
import { match } from 'ts-pattern';
import type { DeviceGenre } from '@/constants/device';
import { cn } from '@/lib/cn';
import { LabelXBase } from '../../../../components/LabelX';
import { AvatarDevice } from '../Avatar/AvatarDevice';
type Props = {
  genre: DeviceGenre;
  name: string;
  /**
   * アバター画像のURL（デバイスの画像が設定されていないことを考慮して、undefinedを許容する）
   */
  avatarUrl?: string;
  /**
   * ホバーしたら大きくなってほしいかどうか
   */
  hoverScale?: boolean;
  /**
   * デバイス管理ID。サブラベルの既定値
   */
  deviceTag?: string;
  /**
   * サブラベルをデバイス管理IDではなく資産タグにするかどうか。
   * trueでもassetTagが空ならdeviceTagにフォールバックする
   */
  showAssetTag?: boolean;
  /**
   * 資産タグ（showAssetTagがtrueかつ値があるときだけサブラベルへ表示される）
   */
  assetTag?: string;
} & Omit<ComponentProps<typeof LabelXBase>, 'label'>;

/**
 * デバイスのアバターとラベルを表示するコンポーネント
 */
export function LabelDevice({
  avatarUrl,
  hoverScale,
  deviceTag,
  showAssetTag = false,
  assetTag,
  ...props
}: Props) {
  const size = match(props.size).with('Default', () => 24 as const).with('Large', () => 32 as const).with('Small', () => 16 as const).with('ExtraSmall', () => 12 as const).otherwise(() => 24 as const);

  // サブラベルの既定はデバイス管理ID。資産タグを出したい画面だけ `showAssetTag` で
  // 差し替える。以前は `deviceTag` を「出すかどうか」の条件にしか使っておらず、
  // 描く値は常に `assetTag` だった。そのため `deviceTag` だけを渡す呼び出し側では
  // 何も出ず、両方渡す呼び出し側では資産タグが出ていた（DC-9404）。
  const subLabel = showAssetTag && assetTag ? assetTag : deviceTag || undefined;
  return <LabelXBase {...props} label={props.name} subLabel={subLabel}>
      <AvatarDevice src={avatarUrl} genre={props.genre} size={size}
    // hoverScaleが指定されているか、previewCardがある場合にhoverScaleをtrueにする
    hoverScale={hoverScale ?? !!props.previewCardContent} className={cn('shrink-0 bg-neutral-muted-fill')} />
    </LabelXBase>;
}